/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_POLICY_LIST: {
    offset: 0,
    size: 1000,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.actualPage.csvDownload',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_POLICY_LIST' },
      },
    },
    GET_POLICY_LIST: {
      invoke: {
        id: 'getPolicyList',
        src: 'getPolicyList',
        onDone: {
          target: 'RENDER_POLICY_LIST',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_POLICY_LIST_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_POLICY_LIST: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_POLICY_LIST',
        },
      },
    },
    RENDER_POLICY_LIST_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
